import { render, staticRenderFns } from "./business.vue?vue&type=template&id=846d8f5a&scoped=true&"
import script from "./business.vue?vue&type=script&lang=ts&"
export * from "./business.vue?vue&type=script&lang=ts&"
import style0 from "./business.vue?vue&type=style&index=0&id=846d8f5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846d8f5a",
  null
  
)

export default component.exports